"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _jobCard = _interopRequireDefault(require("./common/job-card"));
var _notFound = _interopRequireDefault(require("./common/not-found"));
var _search = _interopRequireDefault(require("./common/search"));
var _dropdown = _interopRequireDefault(require("./common/dropdown"));
var _pagination = _interopRequireDefault(require("./common/pagination"));
var _functions = require("./common/functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */

/**
 * Local Imports
 */

const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hpjqa3s"
});
const JobGroup = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "JobGroup",
  class: "pl-j1axq30u"
});

/**
 * JobListingSection Component.
 * @module OpenPositionTable
 *
 * @param {Object} props React props
 * @param {String} props._name Section Tracking name
 * @param {String} props.API_URL Assigned Job API
 * @param {String} props.officeName Overwrites Selected Offices
 * @param {String} props.searchPlaceholder Placeholder for Search Bar
 * @param {string} props.verticalMargin Vertical Outer Spacing value
 * @returns {React.ReactElement} JobListingSection Component
 * @public
 */

function OpenPositionTable({
  _name,
  API_URL = 'https://boards-api.greenhouse.io/v1/boards/godaddy/jobs?content=true',
  officeName,
  searchPlaceholder,
  verticalMargin = 'none',
  ...rest
}) {
  const [isBusy, setBusy] = (0, _react.useState)(true);
  const [data, setData] = (0, _react.useState)([]);
  const [filteredData, setFilteredData] = (0, _react.useState)([]);
  const [q, setQ] = (0, _react.useState)('');
  const [category, setCategory] = (0, _react.useState)([]);
  const [location, setLocation] = (0, _react.useState)([]);
  const [office, setOffice] = (0, _react.useState)(null);
  const [remote, setRemote] = (0, _react.useState)(false);
  const [prev, setPrev] = (0, _react.useState)(null);
  const [department, setDepartment] = (0, _react.useState)(null);
  const [select, setSelected] = (0, _react.useState)([]);
  const pageLimit = 5;
  const [offset, setOffset] = (0, _react.useState)(0);
  const [totalPage, setTotalPage] = (0, _react.useState)(0);
  const [currentPage, setCurrentPage] = (0, _react.useState)(1);

  // Filter Data onSearch
  function search(children) {
    return children?.filter(child => (0, _functions.sortSearchParam)(child?.title || '', q) || (0, _functions.sortSearchParam)(child?.departments[0]?.name || '', q));
  }
  function handleFilterChange(e, filterType) {
    switch (filterType) {
      case 'department':
        setOffset(0);
        setCurrentPage(1);
        setDepartment(e.children);
        break;
      case 'office':
        setOffset(0);
        setCurrentPage(1);
        setOffice(e.itemIndex);
        setPrev(e.children);
        break;
      case 'remote':
        setOffset(0);
        setCurrentPage(1);
        setRemote(true);
        break;
      default:
        break;
    }
  }
  function resetFilter() {
    setQ('');
    setDepartment(null);
    setOffice(null);
    setRemote(false);
    setSelected([]);
    setOffset(0);
    setCurrentPage(1);
  }
  function paginateNext() {
    if (currentPage < totalPage) {
      setCurrentPage(currentPage + 1);
      setOffset(offset + pageLimit);
    }
  }
  function paginatePrev() {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setOffset(offset - pageLimit);
    }
  }
  (0, _react.useEffect)(() => {
    const fetchItems = async () => {
      try {
        const response = await fetch(API_URL);
        const listItems = await response.json();
        setData(listItems.jobs);
        setTotalPage((0, _functions.splitArrToChunks)(listItems.jobs, pageLimit).length);
        setFilteredData(listItems.jobs);
        setBusy(false);
      } catch (err) {
        // eslint-disable-next-line no-undef
        Console.log(err.stack);
      }
    };
    fetchItems();
  }, []);
  (0, _react.useEffect)(() => {
    if (!isBusy) {
      const departments = [];
      const countries = [];
      if (filteredData !== []) {
        filteredData?.map(item => {
          departments?.push({
            value: item.departments[0]?.name
          });
          // eslint-disable-next-line no-undefined
          if (item.offices[0]?.name !== undefined) {
            countries.push({
              value: item.offices[0]?.name
            });
          }
        });
      }
      // Dynamic Unique Item Iterators
      const uniqueDepartments = (0, _functions.sortUniqueItems)(departments);
      const uniqueCountries = (0, _functions.sortUniqueItems)(countries);
      setCategory(uniqueDepartments);
      setLocation((0, _functions.sortAlphabetically)(uniqueCountries));
    }
  }, [isBusy]);

  // Set Officename
  (0, _react.useEffect)(() => {
    if (officeName && office === null) {
      location?.map((item, i) => {
        if (item.value === officeName) {
          setPrev(officeName);
          setOffice(i);
        }
      });
    }
  });

  // Filter Data onChange Dropdown
  (0, _react.useEffect)(() => {
    let filteredJobs = filteredData;
    if (department !== null) {
      filteredJobs = filteredJobs?.filter(job => job.departments[0]?.name === department);
    }
    if (office !== null) {
      filteredJobs = filteredJobs?.filter(job => job.offices[0]?.name === prev);
    }
    if (remote) {
      filteredJobs = filteredJobs?.filter(job => job.metadata[1]?.value);
    }
    if (q === '') {
      setTotalPage((0, _functions.splitArrToChunks)(filteredJobs, pageLimit).length);
    }
    setTotalPage((0, _functions.splitArrToChunks)(search(filteredJobs), pageLimit).length);
    setData(filteredJobs);
  }, [department, office, remote, offset, q]);
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    _name: _name,
    dataCy: "open-position-table",
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, null, /*#__PURE__*/_react.default.createElement(_index.default, rest)), /*#__PURE__*/_react.default.createElement(_search.default, {
    data: data,
    value: q,
    onChange: e => setQ(e),
    placeholder: searchPlaceholder
  }), /*#__PURE__*/_react.default.createElement(_dropdown.default, (0, _extends2.default)({
    location: location,
    officeSelected: office,
    officeOnChange: e => handleFilterChange(e, 'office'),
    category: category,
    categorySelected: select,
    categoryOnChange: e => handleFilterChange(e, 'department'),
    remoteSelected: select,
    remoteOnChange: e => handleFilterChange(e, 'remote'),
    resetFilter: resetFilter
  }, rest)), /*#__PURE__*/_react.default.createElement(JobGroup, {
    "data-cy": "job-group"
  }, search(data).length <= 0 && !isBusy ? /*#__PURE__*/_react.default.createElement(_notFound.default, rest) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, search(data).slice(offset, offset + pageLimit)?.map((job, i) => {
    return /*#__PURE__*/_react.default.createElement(_jobCard.default, (0, _extends2.default)({
      key: i
    }, job, {
      jobTitle: job.title,
      jobDepartment: job.departments[0]?.name,
      jobLocation: job.offices[0]?.name,
      jobUrl: job.absolute_url
    }));
  }))), totalPage !== 0 && /*#__PURE__*/_react.default.createElement(_pagination.default, {
    currentPage: currentPage,
    totalPage: totalPage,
    forwardedPrev: paginatePrev,
    forwardedNext: paginateNext
  }));
}
var _default = exports.default = OpenPositionTable;
OpenPositionTable.propTypes = {
  _name: _propTypes.default.string,
  API_URL: _propTypes.default.string.isRequired,
  officeName: _propTypes.default.string,
  searchPlaceholder: _propTypes.default.string,
  ..._patternLibraryUtils.marginProps
};